/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useStore} from 'src/feature/store/hook'
import StoreUserCreate from './StoreUserCreate'
import {useSearchParams} from 'react-router-dom'
import {useGetStoreContactTitleList} from '../../context/useQuery'

const StoreUsers = ({loading, refetch}: {loading: boolean; refetch: any}) => {
  useGetStoreContactTitleList()
  const intl = useIntl()
  const [, setSearchParams] = useSearchParams()
  const {detail, detailSet, tabFilter, tabFilterSet, storeContactTitleList} = useStore()
  const [newUser, setNewUser] = useState(false)

  const data = detail?.User?.dataList || []

  const paging = detail?.User?.paging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'FirstName',
      dataIndex: 'firstName',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.FIRST_NAME'}),
    },
    {
      key: 'LastName',
      dataIndex: 'lastName',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.LAST_NAME'}),
    },
    {
      key: 'email',
      dataIndex: 'email',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.EMAIL'}),
    },
    {
      key: 'Role',
      dataIndex: 'roleId',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.ROLE'}),
      // render: (roleId: any) => <>{roleId === '0' ? 'Admin' : 'User'}</>,
      render: (roleId: any) => {
        const role = storeContactTitleList?.find((item) => item.id === roleId)
        return <>{role?.name || ''}</>
      },
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.STATUS'}),
      status: true,
    },
    {
      key: 'JoinedDate',
      dataIndex: 'createdOn',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.JOINED_DATE'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'Lastlogin',
      dataIndex: 'lastLogin',
      title: intl.formatMessage({id: 'STORE.DETAIL.USERS.LAST_LOGIN'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'detailURL',
      dataIndex: 'id',
      title: intl.formatMessage({id: 'STORE.DETAIL.COMMISSION.ACTION'}),
      render: (text: string, _) => {
        return (
          <a href='#' onClick={() => setSearchParams({userID: _.id})} style={{cursor: 'pointer'}}>
            {intl.formatMessage({id: 'STORE.DETAIL.COMMISSION.DETAIL'})}
          </a>
        )
      },
    },
  ]

  if (newUser) {
    return (
      <StoreUserCreate
        loading={loading}
        onCancel={() => {
          setNewUser(false)
          refetch()
        }}
      />
    )
  }

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>{intl.formatMessage({id: 'STORE.DETAIL.USERS'})}</h3>
            <p className='text-muted fw-normal fs-6'>
              {intl.formatMessage({id: 'STORE.DETAIL.USERS_TOOLTIP'})}
            </p>
          </div>
        </div>
        <div className='card-title m-0'>
          <button
            className='btn btn-light'
            onClick={() => {
              setNewUser(true)
            }}
          >
            <i className='bi bi-plus-circle-fill fs-2'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
            {intl.formatMessage({id: 'STORE.DETAIL.USERS.CREATE'})}
          </button>
        </div>
      </div>

      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <Table
            loading={loading}
            dataSource={data}
            columns={Columns}
            pagination={{
              current: paging.currentPageNumber,
              pageSize: paging.pageSize,
              total: paging.totalCount,
              onChange: (page: any) => {
                if (!detail || !detail.User) return
                const {pageSize, current} = page
                const currentPage = pageSize !== detail.User.paging.pageSize ? 1 : current

                detailSet({
                  ...detail,
                  User: {
                    ...detail.User,
                    paging: {
                      ...paging,
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  },
                })

                tabFilterSet({
                  ...tabFilter,
                  paging: {
                    currentPageNumber: currentPage,
                    pageSize: pageSize,
                  },
                })
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default StoreUsers
